module.exports = __webpack_public_path__ + "static/img/アセット 85@3x.1c37639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 85@3x.png
// module id = BBCm
// module chunks = 1